import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { MultiSelect } from 'primereact/multiselect';

import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from '../components/ui/card';

import { Button } from '../components/ui/button';
import { Edit, Trash, PlusCircle, Container, EllipsisVertical, Search, X, Calendar, Caravan, Truck, User, Mail, Phone, IdCard } from 'lucide-react';
import Topbar from '../components/Topbar';
import Sidebar from '../components/Sidebar'; // Importa el Sidebar
import { toast, ToastContainer } from 'react-toastify';
import InboundNewModal from '../components/inbound/InboundNewModal';

import { DataGrid } from "@mui/x-data-grid";
import {
  Box, Typography, TextField, Select, Checkbox, ListItemText, InputLabel, OutlinedInput, FormControl, Autocomplete,
  Chip
} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';

import { format, parseISO } from "date-fns"; // Importamos date-fns
import { es } from "date-fns/locale"; // Español

import Modal from '@mui/material/Modal';
import "../css/Inbound.css";
import inboundService from "../services/InboundService";
import TransportistasService from "../services/TransportistasService";
import ConfirmDialog from "../components/ConfirmDialog";
import { useSelector, useDispatch } from "react-redux";
import { setAllInboundContenedores, setAllInbound } from "../redux/slice/InboundSlice";
import { statusClasses, statusNewNames } from '../utils/StatusUtils';
import ShowStatusDialog from '../components/inbound/ShowStatusDialog';
import SimpleMessageDialog from "./../components/SimpleMessageDialog";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ModalGenerateCartPdf from '../components/inbound/ModalGenerateCartPdf';



const Inbound = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState('Inbound');
  const [searchValue, setSearchValue] = useState('');
  const [inboundData, setInboundData] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [openModalcontenedoresDetalle, setOpenModalcontenedoresDetalle] = useState(false);
  const handleClose = () => setOpenModalcontenedoresDetalle(false);
  const [inboundRowSelected, setInboundRowSelected] = useState([]);
  const [formData, setFormData] = useState({
    referencia: '',
    pedimento: '',
    folio: '',
    contenedor: '',
    naviera: '',
    origen: '',
    destino: '',
    puerta_vacio: '',
    cita_carga: '',
    cita_entrega: '',
    estatus: ''
  });

  let allInbound = useSelector((state) => state.inbound.allInbound);
  const dispatch = useDispatch(); // Usar acciones

  const [allStatus, setAllStatus] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const open = Boolean(anchorEl);

  const [isDisabledChangeStatus, setIsDisabledChangeStatus] = useState(false);

  const [openModalDeleteEmbarque, setOpenModalDeleteEmbarque] = useState(false);
  const [openDialogStatus, setOpenDialogStatus] = useState(false);
  const [embarqueSelected, setEmbarqueSelected] = useState(null);
  const [isEditInbound, setIsEditInbound] = useState(false);

  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [globalFilter, setGlobalFilter] = useState("");
  const [expandedRows, setExpandedRows] = useState(null);
  const [referenciaFilter, setReferenciaFilter] = useState('');
  const [cuentasFilter, setCuentasFilter] = useState([]);

  const [estatusFilter, setEstatusFilter] = useState([]);
  const [openModalWarning, setOpenModalWarning] = useState(false);
  const [openModalWarningCartPdf, setOpenModalWarningCartPdf] = useState(false);
  const [openModalCartPdf, setOpenModalCartPdf] = useState(false);


  const [filterDateFechaCarga, setFilterDateFechaCarga] = useState({
    pickupDateRange: [null, null], // Rango de fechas inicial vacío
  });

  const [filterDateFechaUltimoEstado, setfilterDateFechaUltimoEstado] = useState({
    pickupDateRange: [null, null], // Rango de fechas inicial vacío
  });


  const [cuentas, setCuentas] = useState([]);

  const [selectedCities, setSelectedCities] = useState([]);
  const cities = [
    { name: 'New York', code: 'NY' },
    { name: 'Rome', code: 'RM' },
    { name: 'London', code: 'LDN' },
    { name: 'Istanbul', code: 'IST' },
    { name: 'Paris', code: 'PRS' }
  ];



  const rowExpansionTemplate = (data) => {
    const jsonObject = JSON.parse(data.requerimientos_adicionales);
    return (
      <div style={{ padding: "10px", backgroundColor: "#f5f5f5" }} className='flex flex-row justify-between '>

        <div className='flex flex-col border w-[30%]  p-2  text-sm bg-gray-50 p-4 rounded-lg shadow space-y-3'>
          <div className='font-semibold text-lg border-b-2 border-b-dashed'>Detalle Embarque:</div>

          <div className='flex flex-row flex-wrap justify-between'>
            <div className='flex flex-col'>
              <div className='font-bold flex flex-row'>
                <div><Truck></Truck></div>
                <div>Vehiculo</div>
              </div>
              <div className='flex flex-row mr-3'>
                <div className='font-bold mr-1'>
                  Placas:
                </div>
                <div>
                  {data.vehiculo_placas}
                </div>

              </div>

              <div className='flex flex-row'>
                <div className='font-bold mr-1'>
                  Año:
                </div>
                <div>
                  {data.vehiculo_ano}
                </div>

              </div>

              <div className='flex flex-row'>
                <div className='font-bold mr-1'>
                  Tipo:
                </div>
                <div>
                  {data.vehiculo_tipo}
                </div>

              </div>

              <div className='flex flex-row'>
                <div className='font-bold mr-1'>
                  Modelo:
                </div>
                <div>
                  {data.vehiculo_modelo}
                </div>
              </div>

              <div className='flex flex-row'>
                <div className='font-bold mr-1'>
                  Color:
                </div>
                <div>
                  {data.vehiculo_color}
                </div>

              </div>

            </div>

            <div className='flex flex-col'>
              <div className='font-bold flex flex-row'>
                <div><Caravan></Caravan></div>
                <div>Remolque</div>
              </div>
              <div className='flex flex-row'>
                <div className='font-bold mr-1'>
                  Placas:
                </div>
                <div>
                  {data.remolque1_placas}
                </div>

              </div>

              <div className='flex flex-row'>
                <div className='font-bold mr-1'>
                  Año:
                </div>
                <div>
                  {data.remolque1_ano}
                </div>

              </div>

              <div className='flex flex-row'>
                <div className='font-bold mr-1'>
                  Tipo:
                </div>
                <div>
                  {data.remolque1_tipo}
                </div>

              </div>

              <div className='flex flex-row'>
                <div className='font-bold mr-1'>
                  Modelo:
                </div>
                <div>
                  {data.remolque1_modelo}
                </div>
              </div>

              <div className='flex flex-row'>
                <div className='font-bold mr-1'>
                  Color:
                </div>
                <div>
                  {data.remolque1_color}
                </div>

              </div>

              <div className='flex flex-row'>
                <div className='font-bold mr-1'>
                  Economico:
                </div>
                <div>
                  {data.remolque1_economico}
                </div>

              </div>

            </div>

            {data.id_remolque2 && (
              <div className='flex flex-col'>
                <div className='font-bold flex flex-row'>
                  <div><Caravan></Caravan></div>
                  <div>Remolque2</div>
                </div>
                <div className='flex flex-row'>
                  <div className='font-bold mr-1'>
                    Placas:
                  </div>
                  <div>
                    {data.remolque2_placas}
                  </div>

                </div>

                <div className='flex flex-row'>
                  <div className='font-bold mr-1'>
                    Año:
                  </div>
                  <div>
                    {data.remolque2_ano}
                  </div>

                </div>

                <div className='flex flex-row'>
                  <div className='font-bold mr-1'>
                    Tipo:
                  </div>
                  <div>
                    {data.remolque2_tipo}
                  </div>

                </div>

                <div className='flex flex-row'>
                  <div className='font-bold mr-1'>
                    Modelo:
                  </div>
                  <div>
                    {data.remolque2_modelo}
                  </div>
                </div>

                <div className='flex flex-row'>
                  <div className='font-bold mr-1'>
                    Color:
                  </div>
                  <div>
                    {data.remolque2_color}
                  </div>

                </div>

                <div className='flex flex-row'>
                  <div className='font-bold mr-1'>
                    Economico:
                  </div>
                  <div>
                    {data.remolque2_economico}
                  </div>

                </div>

              </div>
            )}
          </div>

        </div>

        <div className='flex flex-col border w-[30%]  p-2  text-sm bg-gray-50 p-4 rounded-lg shadow space-y-3'>
          <div className='font-semibold text-lg border-b-2 border-b-dashed'>Detalle operador:</div>
          <div className='flex flex-row'>
            <div className='font-bold mr-1 flex flex-row'>
              <div><User size={17}></User> </div>
              <div>Nombre:</div>
            </div>
            <div className='lowercase capitalize'>
              {data.operador_nombre.toLowerCase()} {data.operador_apellido_paterno.toLowerCase()} {data.operador_apellido_materno.toLowerCase()}
            </div>
          </div>

          <div className='flex flex-row'>
            <div className='font-bold mr-1 flex flex-row'>
              <div><Mail size={17}></Mail> </div>
              <div>Email:</div>
            </div>
            <div>{data.operador_email}</div>
          </div>

          <div className='flex flex-row'>
            <div className='font-bold mr-1 flex flex-row'>
              <div><Phone size={17}></Phone> </div>
              <div>Telefono:</div>
            </div>
            <div>
              {data.operador_telefono}
            </div>
          </div>

          <div className='flex flex-row'>
            <div className='font-bold mr-1 flex flex-row'>
              <div><IdCard size={17}></IdCard> </div>
              <div>Licencia:</div>
            </div>
            <div>
              {data.operador_licencia}
            </div>

          </div>

        </div>



        <div className='flex flex-col border w-[30%]  p-2  text-sm bg-gray-50 p-4 rounded-lg shadow space-y-3'>
          <div className='font-semibold text-lg border-b-2 border-b-dashed'>Requerimientos Adicionales:</div>
          <div>
            <ul className='list-disc list-inside'>
              {jsonObject.map(item => (
                <li key={item.id}>{item.requerimiento}</li>
              ))}
            </ul>
          </div>

        </div>

      </div>
    );
  };

  const handleChange = (event) => {
    setEstatusFilter(event);
  };


  const handleFilterCuentaChange = (value) => {
    // debugger
    // const { value } = event.target;

    if (value.includes("all")) {
      // Si se selecciona "Todos", marca o desmarca todos los elementos
      setCuentasFilter(
        cuentasFilter.length === 0 ? cuentas.map((cuenta) => cuenta.id) : []
      );
    } else {
      setCuentasFilter(value);
    }

  };



  const handleOpenModalContenedoresDetalle = (rowParams) => {

    setOpenModalcontenedoresDetalle(true);
    setInboundRowSelected(rowParams.contenedores);
  };



  const handleMenuClick = (event, row) => {

    if (row.id_status_of_inbound === 7) {
      setIsDisabledChangeStatus(true)
    }
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
    setIsDisabledChangeStatus(false)
  };

  const handleMenuOnlyClose = () => {
    setAnchorEl(null);
    setIsDisabledChangeStatus(false)
  };

  const canGeneratePDF = () => {
    console.log(selectedRow)
    // return
    if (selectedRow) {
      if (selectedRow.contenedores.length > 0) {

        // changeStatus(selectedRow)
        setOpenModalCartPdf(true)
        handleMenuOnlyClose();

      } else {
        setOpenModalWarningCartPdf(true)
        handleMenuClose();
      }
    }
   
  };

  const checkWhatisTheNextStatus = () => {
    console.log(selectedRow)
    // return
    if (selectedRow) {
      if (selectedRow.contenedores.length > 0) {

        changeStatus(selectedRow)

      } else {
        setOpenModalWarning(true)
      }
    }
    handleMenuClose();
  };

  const showDisableActionButtons = (row) => {
    // En este caso, simplemente retornamos true, pero puedes cambiar la lógica
    if (row.id_status_of_inbound > 1) {
      return true;
    }
    return false; // Cambia esto según tus necesidades
  };

  const handleOpenDialogStatus = (row) => {

    setOpenDialogStatus(true);
    setInboundRowSelected(row);
  };

  const handleCloseDialogStatus = (row) => {

    setOpenDialogStatus(false);
    setInboundRowSelected(null);
  };

  const dateTemplate = (rowData) => {
    const dateFormated = format(parseISO(rowData.fecha_de_carga), "dd/MM/yyyy HH:mm:ss", { locale: es });
    return dateFormated;
  };

  const dateTemplate2 = (rowData) => {
    const dateFormated = format(parseISO(rowData.fecha), "dd/MM/yyyy HH:mm:ss", { locale: es });
    return dateFormated;
  };


  const estatusTemplate = (rowData) => {
    const status = rowData.estatus;
    return (
      <div
        onClick={() => handleOpenDialogStatus(rowData)}
        className={`${statusClasses[status]} text-black font-bold px-2 py-1 inline-flex items-center justify-center w-full h-[75%] rounded cursor-pointer`}
      >
        {statusNewNames[status]}
      </div>
    );
  };

  const showContenedoresTemplate = (rowData) => {
    // const status = rowData.estatus;
    // console.log(rowData);

    return (

      <div className="flex justify-center items-center w-full h-full">

        <Button variant="destructive" onClick={() => handleOpenModalContenedoresDetalle(rowData)}>
          <Tooltip title="Ver Contenedores">

            <Container className="w-4 h-4" />
          </Tooltip>

        </Button>
      </div>
    );
  };


  const renderActions = (rowData) => (
    <Box className="flex items-center justify-around h-full">

      <Button variant="destructive" onClick={() => handleEditEmbarque(rowData)} disabled={showDisableActionButtons(rowData)} className={`${showDisableActionButtons(rowData) ? "opacity-50 cursor-not-allowed" : ""}`}>
        <Tooltip title="Editar">
          <Edit className="w-4 h-4" />
        </Tooltip>
      </Button>

      <Button variant="destructive" onClick={() => handleDeleteEmbarque(rowData)} disabled={showDisableActionButtons(rowData)} className={`${showDisableActionButtons(rowData) ? "opacity-50 cursor-not-allowed" : ""}`} >
        <Tooltip title="Borrar">
          <Trash className="w-4 h-4" />
        </Tooltip>
      </Button>

      <Button
        variant="destructive"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(event) => handleMenuClick(event, rowData)}
        className="m-0 p-0"
      >
        <Tooltip title="Opciones">
          <EllipsisVertical className="w-4 h-4" />
        </Tooltip>
      </Button>
    </Box>
  );


  const itemTemplate = (option) => {
    // Personalizar cómo se muestra cada opción en el desplegable
    console.log("template", option);

    return (
      <div className="custom-item">
        <span>{statusNewNames[option.estatus]}</span> {/* Personaliza cómo mostrar el estatus */}
        <span className="custom-description">{option.value}</span> {/* Puedes añadir más información, como 'value' */}
      </div>
    );
  };

  const selectedItemTemplate = () => {
    // Personalizar cómo se muestra el objeto completo en el input
    if (estatusFilter.length === 0) {
      return 'Filtra por estatus';
    }

    return estatusFilter.map(item => `${statusNewNames[item.estatus]}`).join(', ');
  };


  const columnsContenedoresDetalle = [

    { field: "nombre_cuenta", headerName: "Cuenta", flex: 1 },
    { field: "pedimento", headerName: "Pedimento", flex: 1 },
    { field: "folio", headerName: "Folio", flex: 1 },
    { field: "contenedor", headerName: "Contenedor", flex: 1 },
    { field: "cantidad", headerName: "Cantidad", flex: 1 },
    { field: "nombre_origen", headerName: "Origen", flex: 1 },
    { field: "nombre_naviera", headerName: "Naviera", flex: 1 },
    { field: "nombre_bodega", headerName: "Bodega", flex: 1 },
    { field: "nombre_puerta_vacio", headerName: "Puerta Vacio", flex: 1 },
    {
      field: "hora_de_cita", headerName: "Hora de cita", flex: 1,

      valueFormatter: (params) => {
        if (params) {

          const dateFormated = format(parseISO(params), "dd/MM/yyyy HH:mm:ss", { locale: es })

          return dateFormated;
        } else {
          return "";
        }

      }
    },
  ];



  const [editIndex, setEditIndex] = useState(null); // Para manejar la edición
  const navigate = useNavigate();

  const handleLogout = () => {
    console.log('Logout clicked!');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    setTimeout(() => {
      navigate('/login');
    }, 0);
  };

  const openModal = (index = null) => {
    console.log("abrir modal prime");


    setModalIsOpen(true);
  };

  const closeModal = () => {

    setModalIsOpen(false)
    setIsEditInbound(false)

  };

  const handlePickupDateRangeChange = (dates) => {
    const [start, end] = dates;
    setFilterDateFechaCarga({
      ...filterDateFechaCarga,
      pickupDateRange: [start, end], // Actualiza el estado con el rango seleccionado
    });
  };

  const handleClearPickupDateRange = () => {
    setFilterDateFechaCarga({
      ...filterDateFechaCarga,
      pickupDateRange: [null, null], // Vacía el rango de fechas
    });
  };

  const handlePickupDateRangeChange2 = (dates) => {
    const [start, end] = dates;
    setfilterDateFechaUltimoEstado({
      ...filterDateFechaUltimoEstado,
      pickupDateRange: [start, end], // Actualiza el estado con el rango seleccionado
    });
  };

  const handleClearPickupDateRange2 = () => {
    setfilterDateFechaUltimoEstado({
      ...filterDateFechaUltimoEstado,
      pickupDateRange: [null, null], // Vacía el rango de fechas
    });
  };


  const handleDeleteEmbarque = async (row) => {
    setOpenModalDeleteEmbarque(true);
    setEmbarqueSelected(row);
  };

  const handleEditEmbarque = async (row) => {

    setIsEditInbound(true);
    setModalIsOpen(true);
    setEmbarqueSelected(row);
    // setEmbarqueSelected(row);
  };



  const handleConfirmDeleteEmbarque = async () => {
    setOpenModalDeleteEmbarque(false);

    try {

      if (embarqueSelected) {
        const responseDeleteEmbarque = await inboundService.deleteEmbarque(embarqueSelected.id);
        if (responseDeleteEmbarque.status === 200) {
          toast.success('Registro eliminado exitosamente');


        }

      }
    } catch (error) {
      console.log(error);
      toast.error("Ocurrió un error: " + error.message);

    }

    setEmbarqueSelected(null);
  };


  const changeStatus = async (rowValue) => {
    try {

      let bodyChangeStatus = {
        id_current_status: rowValue.id_status_of_inbound,
        id_inbound: rowValue.id
      }
      const response = await inboundService.postChangeStatus(bodyChangeStatus);

      if (response.status === 200) { // Verifica si el servidor devuelve 200
        toast.success("¡Operación exitosa!");
        const responseShiptments = await inboundService.getShipments();
        if (responseShiptments.status != 200) {
          throw new Error('Error al obtener los datos');
        }
        const data = await responseShiptments.data;
        setInboundData(data);
      } else {
        console.error(`Error: El servidor respondió con estado ${response.status}`);
        toast.error("Hubo un error");
      }


    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al cargar los datos');
    }
  };


  const onInit = async () => {
    try {
      const response = await inboundService.getShipments();

      if (response.status === 200) {
        const data = response.data; // axios ya hace el parseo de JSON
        dispatch(setAllInbound(data));
      }

      const response2 = await inboundService.getStatusOfInbound();
      if (response2.status != 200) {
        throw new Error('Error al obtener los datos');
      }
      const data2 = await response2.data;
      setAllStatus(data2);

      const response3 = await inboundService.getContenedores();

      if (response3.status === 200) {
        const data3 = response3.data; // axios ya hace el parseo de JSON
        const newContenedores = data3.filter(contenedor => contenedor.estatus === "sin asignar")
        dispatch(setAllInboundContenedores(newContenedores));
      }

      const responseCuentas = await TransportistasService.getCuentas();

      if (responseCuentas.status == 200 && responseCuentas.data) {
        setCuentas(responseCuentas.data)
      }

      setIsDataLoaded(true);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al cargar los datos');
    }
  };

  const updateShipmentInbound = async () => {
    try {
      const response = await inboundService.getShipments();

      if (response.status === 200) {
        const data = response.data; // axios ya hace el parseo de JSON
        setInboundData(data);
      }



    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al cargar los datos');
    }
  };

  const conectarWebSocket = () => {
    const roomId = "salaInbound";
    const ws = new WebSocket(`${process.env.REACT_APP_WEB_SOCKET_URL}/${roomId}`);

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log(data);

      // Acción para crear
      if (data.action === "create" && data.id_inbound) {
        const newInbound = data.data;

        // Accedemos al estado actualizado usando una función de callback en el dispatch
        dispatch((dispatch, getState) => {
          const currentAllInbound = getState().inbound.allInbound;


          const updatedInbound = [newInbound, ...currentAllInbound];

          // Despachar la acción con el nuevo array
          dispatch(setAllInbound(updatedInbound));
        });
      }

      // Acción para eliminar
      if (data.action === "delete" && data.id_inbound) {
        dispatch((dispatch, getState) => {
          const currentAllInbound = getState().inbound.allInbound;

          // Filtrar el ítem eliminado
          const updatedInbound = currentAllInbound.filter(inbound => inbound.id !== data.id_inbound);

          dispatch(setAllInbound(updatedInbound));
        });
      }

      // Acción para actualizar
      if (data.action === "update" && data.id_inbound) {
        const updatedItem = data.data;  // El nuevo ítem que se quiere reemplazar

        dispatch((dispatch, getState) => {
          const currentAllInbound = getState().inbound.allInbound;

          // Reemplazar el ítem por su id
          const updatedInbound = currentAllInbound.map(inbound =>
            inbound.id === updatedItem.id ? updatedItem : inbound
          );

          dispatch(setAllInbound(updatedInbound));
        });
      }

      if (data.action === "create" && data.id_contenedor) {
        const newContenedor = data.data;

        // Accedemos al estado actualizado usando una función de callback en el dispatch
        dispatch((dispatch, getState) => {
          const currentAllContenedores = getState().inbound.allContenedores;


          const updatedContenedores = [newContenedor, ...currentAllContenedores];

          // Despachar la acción con el nuevo array
          dispatch(setAllInboundContenedores(updatedContenedores));
        });
      }

      if (data.action === "delete" && data.id_contenedor) {
        dispatch((dispatch, getState) => {
          const currentAllContenedores = getState().inbound.allContenedores;

          // Filtrar el ítem eliminado
          const updatedContenedores = currentAllContenedores.filter(contenedor => contenedor.id_contenedor !== data.id_contenedor);

          dispatch(setAllInboundContenedores(updatedContenedores));
        });
      }

      if (data.action === "update" && data.id_contenedor) {
        const updatedItem = data.data;  // El nuevo ítem que se quiere reemplazar

        dispatch((dispatch, getState) => {
          const currentAllContenedores = getState().inbound.allContenedores;

          // Reemplazar el ítem por su id
          const updatedContenedores = currentAllContenedores.map(
            contenedor => contenedor.id_contenedor === updatedItem.id_contenedor ? updatedItem : contenedor
          );

          dispatch(setAllInboundContenedores(updatedContenedores));
        });
      }
    };

    ws.onerror = (error) => console.error("WebSocket error:", error);
    ws.onclose = () => console.log("WebSocket cerrado");

    return ws;
  };

  const filterData = () => {
    return allInbound.filter((data) => {

      // Filtrar por referencia
      const referenciaMatch = referenciaFilter
        ? data.referencia.toLowerCase().includes(referenciaFilter.toLowerCase())
        : true;

      const [startDate, endDate] = filterDateFechaCarga.pickupDateRange;
      const fechaMatch = startDate && endDate
        ? (startDate.getTime() === endDate.getTime())
          ? new Date(data.fecha_de_carga).setHours(0, 0, 0, 0) === startDate.setHours(0, 0, 0, 0)
          : (!startDate || new Date(data.fecha_de_carga) >= new Date(startDate)) &&
          (!endDate || new Date(data.fecha_de_carga) <= new Date(endDate))
        : true;

      const [startDate2, endDate2] = filterDateFechaUltimoEstado.pickupDateRange;
      const fechaMatch2 = startDate2 && endDate2
        ? (startDate2.getTime() === endDate2.getTime())
          ? new Date(data.fecha).setHours(0, 0, 0, 0) === startDate2.setHours(0, 0, 0, 0)
          : (!startDate2 || new Date(data.fecha) >= new Date(startDate2)) &&
          (!endDate2 || new Date(data.fecha) <= new Date(endDate2))
        : true;


      const cuentaMatch = cuentasFilter && cuentasFilter.length > 0
        ? cuentasFilter.some(cuentaFilter => cuentaFilter.id === data.id_cuenta)
        : true;


      const estatusMatch = estatusFilter && estatusFilter.length > 0
        ? estatusFilter.some(estatus => estatus.id_status_of_ibound === data.id_status_of_inbound)
        : true;


      return referenciaMatch && fechaMatch && fechaMatch2 && cuentaMatch && estatusMatch;
    });
  };



  useEffect(() => {


    onInit();
  }, []);

  useEffect(() => {
    if (isDataLoaded) {
      const ws = conectarWebSocket(); // Conectar WebSocket

      return () => ws.close(); // Cerrar WebSocket cuando el componente se desmonta
    }
  }, [isDataLoaded]); // Solo se ejecuta cuando los datos están cargados



  return (
    <div className="flex">


      <Sidebar
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        onLogout={handleLogout}
      />

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem onClick={checkWhatisTheNextStatus} disabled={isDisabledChangeStatus}>
          Cambiar al siguiente estado
        </MenuItem>
        <MenuItem onClick={canGeneratePDF}>
          Generar carta de instrucción
        </MenuItem>
      </Menu>

      <div className={`transition-all duration-300 flex-1 ${sidebarOpen ? 'ml-64' : 'ml-16'} bg-gray-100 min-h-screen p-6`}>
        {/* Replace with Topbar component */}
        <Topbar

          searchValue={searchValue}
          onSearchChange={setSearchValue}
        />

        <div className="mt-6">




          <Card className="shadow-lg">

            <CardContent>

              <div className="card">
                {/* Input de búsqueda global */}

                <div className='flex flex-row mb-3 justify-between'>

                  <div>
                    <CardTitle>Inbound</CardTitle>
                    <div className="mt-6">
                      <Button className="flex items-center" onClick={() => openModal()}>
                        <PlusCircle className="w-8 h-8 mr-2" />
                        Nuevo Embarque
                      </Button>
                    </div>
                  </div>

                  <div className='mt-1'>
                    <TextField
                      label="Buscar..."
                      variant="outlined"
                      fullWidth
                      value={globalFilter}
                      onChange={(e) => setGlobalFilter(e.target.value)}
                      slotProps={{
                        input: {
                          startAdornment: (
                            <Search style={{ marginRight: '8px', color: '#757575' }} />
                          ),
                          style: {
                            backgroundColor: '#fff', // Color de fondo del input
                          },
                        },
                      }}
                    />
                  </div>

                </div>

                <div className='flex flex-row mb-3 justify-start'>
                  <div className='mr-3'>
                    <TextField
                      value={referenciaFilter}
                      onChange={(e) => setReferenciaFilter(e.target.value)}
                      label="Filtra por referencia" // Etiqueta que aparecerá arriba cuando el campo tiene foco o tiene valor
                      slotProps={{
                        input: {
                          style: {
                            backgroundColor: '#fff', // Color de fondo del input
                          },
                        },
                        inputLabel: {
                          shrink: referenciaFilter !== '' || undefined, // Hace que la etiqueta se mueva arriba si hay un valor
                        },

                      }}
                      variant="outlined" // Puedes cambiar el estilo del TextField a `filled` si lo prefieres
                    />
                  </div>

                  <div className="flex flex-row mr-3">
                    <DatePicker
                      selected={filterDateFechaCarga.pickupDateRange[0]} // Fecha de inicio seleccionada
                      onChange={handlePickupDateRangeChange} // Maneja el cambio de fecha
                      startDate={filterDateFechaCarga.pickupDateRange[0]} // Fecha de inicio del rango
                      endDate={filterDateFechaCarga.pickupDateRange[1]} // Fecha de fin del rango
                      selectsRange // Permite seleccionar un rango de fechas
                      placeholderText="Fecha de carga" // Texto que aparece cuando no se selecciona ninguna fecha
                      className="px-3 border border-gray-300 rounded-l-md w-full h-full" // Esquinas redondeadas solo a la izquierda
                      dateFormat="yyyy/MM/dd" // Formato de fecha
                    />

                    <button onClick={() => handleClearPickupDateRange()} className="flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white py-1 px-3 rounded-r-md h-full">
                      <X size={20} />
                    </button>
                  </div>


                  <div className="flex flex-row mr-3">
                    <DatePicker
                      selected={filterDateFechaUltimoEstado.pickupDateRange[0]} // Fecha de inicio seleccionada
                      onChange={handlePickupDateRangeChange2} // Maneja el cambio de fecha
                      startDate={filterDateFechaUltimoEstado.pickupDateRange[0]} // Fecha de inicio del rango
                      endDate={filterDateFechaUltimoEstado.pickupDateRange[1]} // Fecha de fin del rango
                      selectsRange // Permite seleccionar un rango de fechas
                      placeholderText="Fecha de estado" // Texto que aparece cuando no se selecciona ninguna fecha
                      className="px-3 border border-gray-300 rounded-l-md w-full h-full" // Estilos del DatePicker
                      dateFormat="yyyy/MM/dd" // Formato de fecha
                    />
                    <button onClick={() => handleClearPickupDateRange2()} className="flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white py-1 px-3 rounded-r-md h-full">
                      <X size={20} />
                    </button>
                  </div>

                  <div className='mr-3'>
                    <MultiSelect id='newSelect' showClear={true} value={cuentasFilter} onChange={(e) => handleFilterCuentaChange(e.value)} options={cuentas} optionLabel="nombre_cuenta"
                      filter placeholder="Filtra por cuenta" maxSelectedLabels={1} className="w-full md:w-20rem" />
                  </div>


                  {/* <div className="w-full max-w-xs">
                    <Autocomplete
                      multiple
                      id="multiple-autocomplete"
                      options={allStatus} // Lista de opciones
                      getOptionLabel={(option) =>
                        // option.estatus.replace(/\b                                                                                                                            w/g, (char) => char.toUpperCase())

                        statusNewNames[option.estatus]
                      }
                      value={estatusFilter} // Las opciones seleccionadas
                      onChange={handleChange} // Maneja el cambio de selección
                      */}

                  <div className='mr-3'>
                    <MultiSelect id='newSelect'
                      showClear={true}
                      value={estatusFilter}
                      options={allStatus}
                      onChange={(e) => handleChange(e.value)}
                      itemTemplate={itemTemplate}
                      selectedItemTemplate={selectedItemTemplate}
                      filter
                      placeholder="Filtra por estatus"
                      maxSelectedLabels={1}
                      className="w-full md:w-20rem" />
                  </div>


                </div>


                {/* Tabla con filas expandibles */}
                <DataTable
                  value={filterData()}
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 20]}
                  globalFilter={globalFilter}
                  stripedRows
                  showGridlines
                  scrollable
                  expandedRows={expandedRows}
                  onRowToggle={(e) => setExpandedRows(e.data)}
                  rowExpansionTemplate={rowExpansionTemplate}
                  size="small"
                  style={{ width: '100%' }}
                  removableSort
                  rowClassName="hover:bg-blue-100 "
                  resizableColumns
                >
                  <Column expander style={{ width: "3rem" }}
                    headerStyle={{ backgroundColor: '#fff' }}
                  />

                  <Column field="nombre_cuenta" header="Cuenta" sortable
                    headerStyle={{ backgroundColor: '#fff', fontSize: '14px', padding: '4px 8px' }} // 👈 Padding del encabezado
                    bodyStyle={{ fontSize: '14px', padding: '2px 4px' }} // 👈 Padding de las celdas
                    style={{ width: '200px' }} // 👈 Ancho de la columna
                  />

                  <Column field="fecha_de_carga" header="Fecha de carga" sortable body={dateTemplate}
                    headerStyle={{ backgroundColor: '#fff', fontSize: '14px', padding: '4px 8px' }} // 👈 Padding del encabezado
                    bodyStyle={{ fontSize: '14px', padding: '2px 4px' }} // 👈 Padding de las celdas
                    style={{ width: '200px' }} // 👈 Ancho de la columna
                  />

                  <Column field="linea_transporte" header="Linea de transporte" sortable
                    style={{ width: '200px' }}  // 👈 Aplica ancho a la celda de datos
                    headerStyle={{ backgroundColor: '#fff', fontSize: '14px', width: '200px' }}  // 👈 Aplica ancho al encabezado
                    bodyStyle={{ fontSize: '14px', padding: 0 }}
                  />

                  <Column field="operador_nombre" header="Operador" sortable
                    headerStyle={{ backgroundColor: '#fff' }}
                    bodyStyle={{ fontSize: '14px', padding: 0 }}
                  />

                  <Column field="vehiculo_placas" header="Vehiculo" sortable
                    headerStyle={{ backgroundColor: '#fff' }}
                    bodyStyle={{ fontSize: '14px', padding: "0px 10px" }}
                  />

                  <Column field="referencia" header="Referencia" sortable
                    headerStyle={{ backgroundColor: '#fff' }}
                    bodyStyle={{ fontSize: '14px', padding: 0 }}
                  />

                  <Column field="estatus" header="Estatus" sortable body={estatusTemplate}
                    headerStyle={{ backgroundColor: '#fff' }}
                    bodyStyle={{ fontSize: '14px', padding: 0 }}
                  />

                  <Column field="fecha" header="Fecha" sortable body={dateTemplate2}
                    style={{ width: '200px' }}  // 👈 Aplica ancho a la celda de datos
                    headerStyle={{ backgroundColor: '#fff', fontSize: '14px', width: '200px' }}  // 👈 Aplica ancho al encabezado
                    bodyStyle={{ fontSize: '14px', padding: "5px 5px px 2px" }}
                  />

                  <Column field="contenedores" header="Contenedores" body={showContenedoresTemplate}
                    style={{ width: '200px' }}  // 👈 Aplica ancho a la celda de datos
                    headerStyle={{ backgroundColor: '#fff', fontSize: '14px', width: '200px' }}  // 👈 Aplica ancho al encabezado
                    bodyStyle={{ padding: 0 }}
                  />

                  <Column field="contenedores" header="Acciones" body={renderActions}
                    style={{ width: '300px' }}  // 👈 Aplica ancho a la celda de datos
                    headerStyle={{ backgroundColor: '#fff', fontSize: '14px', width: '300px', padding: "0px 40px 0px 0px" }}  // 👈 Aplica ancho al encabezado
                    bodyStyle={{ fontSize: '14px', padding: 0 }}
                  />


                </DataTable>
              </div>
            </CardContent>
          </Card>




        </div>
      </div>
      <ToastContainer />

      <InboundNewModal
        isOpen={modalIsOpen}
        onClose={() => closeModal()}
        // onSubmit={handleSubmit}
        formData={formData}
        setFormData={setFormData}
        setModalIsOpen={setModalIsOpen}
        setInboundData={setInboundData}
        isEditInbound={isEditInbound}
        embarqueSelected={embarqueSelected}
        updateShipmentInboundParent={() => updateShipmentInbound()}
      />

      <Modal open={openModalcontenedoresDetalle} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            bgcolor: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >

          <div>
            <DataGrid rows={inboundRowSelected} columns={columnsContenedoresDetalle}
              getRowId={(row) => row.id_contenedor}
              pageSizeOptions={[10, 25, 50]}
              hideFooter
            />

          </div>
          <Button sx={{ mt: 2 }} variant="contained" onClick={handleClose}>
            Cerrar
          </Button>
        </Box>
      </Modal>

      <ConfirmDialog
        open={openModalDeleteEmbarque}
        onClose={() => setOpenModalDeleteEmbarque(false)}
        onConfirm={() => handleConfirmDeleteEmbarque()}
        title="Eliminar Embarque"
        message="¿Estás seguro de que quieres eliminar este registro? Esta acción no se puede deshacer."
        icon="warning"
      />

      <ShowStatusDialog
        open={openDialogStatus}
        allStatus={allStatus}
        inboundRowSelected={inboundRowSelected}
        onClose={() => handleCloseDialogStatus()}
      />

      <SimpleMessageDialog
        open={openModalWarning}
        onClose={() => setOpenModalWarning(false)}
        title="Aviso"
        message="No puedes cambiar de estado. No tienes contenedores asignados en el embarque"
        icon="warning"
      />

      <SimpleMessageDialog
        open={openModalWarningCartPdf}
        onClose={() => setOpenModalWarningCartPdf(false)}
        title="Aviso"
        message="No puedes generar la carta de instrucciones. No tienes contenedores asignados en el embarque"
        icon="warning"
      />

      <ModalGenerateCartPdf
        open={openModalCartPdf}
        selectedRowInbound={selectedRow}
        onClose={() => setOpenModalCartPdf(false)}
      />

    </div>
  );
};

export default Inbound;